/**
 * Construct representation of navigation menu
 *
 * @param {*} config Configuration object
 * @param {Store} store Application store
 * @return {*[]} Menu object
 */
export default function(config, store) {
  // Helper function
  const hasPermission = (permission) => store.state.auth
    .user.scopes.auth.permissions.indexOf(permission) > -1;

  const menuItems = [
    {
      label: 'Dashboard',
      icon: 'dashboard',
      to: '/',
      authorized: () => true
    },
    {
      label: 'Employees',
      route: '/users',
      icon: 'supervisor_account',
      authorized: () => {
        if (hasPermission('VIEW_ALL_DATA') ||
          hasPermission('EDIT_ALL_USERS') ||
          store.state.auth.groups.length > 0) {
          return true;
        }

        return store.state.auth.groups.length > 0;
      },
      children: [
        {
          label: 'Employee access',
          to: '/users',
          authorized: () => {
            if (hasPermission('VIEW_ALL_DATA') ||
              hasPermission('EDIT_ALL_USERS')) {
              return true;
            }

            return store.state.auth.groups.length > 0;
          },
          click: () => {
            store.dispatch('users/reset');
          }
        },
        {
          label: 'Groups',
          to: '/groups',
          authorized: () => {
            if (hasPermission('VIEW_ALL_DATA') ||
              hasPermission('EDIT_ALL_USERS') ||
              store.state.auth.groups.length > 0) {
              return true;
            }

            return store.state.auth.groups.length > 0;
          },
          click: () => {
            store.dispatch('groups/reset');
          }
        }
      ]
    }
  ];

  // Add approval flows
  const requestMenuItem = {
    label: 'Requests',
    icon: 'check_circle',
    to: '/approvals',
    authorized: () => true
  };
  if (hasPermission('VIEW_ALL_DATA') || hasPermission('EDIT_ALL_USERS')) {
    menuItems.push(
      {
        label: 'Approvals',
        icon: 'check_circle',
        route: '/approvals',
        authorized: () => true,
        children: [
          requestMenuItem,
          {
            label: 'Manage flows',
            to: '/approvals/flows',
            authorized: () => true,
            click: () => {
              store.dispatch('approvals/resetFlows');
            }
          }
        ]
      }
    );
  } else {
    requestMenuItem.label = 'Approvals';
    menuItems.push(requestMenuItem);
  }

  menuItems.push(
    {
      label: 'Tokens',
      icon: 'vpn_key',
      to: '/tokens',
      authorized: () => hasPermission('MANAGE_TOKENS') ||
        hasPermission('VIEW_ALL_DATA') ||
        hasPermission('EDIT_ALL_USERS')
    },
    {
      label: 'Messaging',
      icon: 'fa-envelope',
      route: '/messaging',
      authorized: () => store.state.auth.user.scopes.messaging &&
        ((authorities) => authorities.indexOf('READ_TEMPLATES') > -1 ||
          authorities.indexOf('WRITE_TEMPLATES') > -1 ||
          authorities.indexOf('READ_LOGS') > -1 ||
          authorities.indexOf('MANAGE_USER_CONFIGURATIONS') > -1)(
          store.state.auth.user.scopes.messaging.authorities
        ),
      children: [
        {
          label: 'Templates',
          to: '/messaging/templates',
          authorized: () => store.state.auth.user.scopes.messaging.authorities
            .indexOf('READ_TEMPLATES') > -1 ||
            store.state.auth.user.scopes.messaging.authorities.indexOf('WRITE_TEMPLATES') > -1
        },
        {
          label: 'Users',
          to: '/messaging/users',
          authorized: () => store.state.auth.user.scopes.messaging.authorities
            .indexOf('MANAGE_USER_CONFIGURATIONS') > -1,
          click: () => store.dispatch('messaging/resetUsers')
        },
        {
          label: 'Logs',
          to: '/messaging/logs',
          authorized: () => store.state.auth.user.scopes.messaging.authorities
            .indexOf('READ_LOGS') > -1
        }
      ]
    },
    {
      label: 'Audit history',
      icon: 'assignment_late',
      to: '/audit',
      authorized: () => hasPermission('VIEW_ALL_DATA') ||
        hasPermission('EDIT_ALL_USERS'),
      click: () => {
        store.dispatch('audit/reset');
      }
    },
    {
      label: 'Settings',
      icon: 'settings',
      route: '/settings',
      authorized: () => true,
      children: [
        {
          label: 'Notifications',
          to: '/settings/notifications',
          authorized: () => true
        },
        {
          label: 'Integrations',
          to: '/settings/integrations',
          authorized: () => true
        }
      ]
    },
    {
      label: 'Switch user',
      icon: 'code',
      authorized: () => config.allowSwitchUser,
      click: () => store.commit('auth/switchUserModal', true)
    }
  );

  return menuItems;
}
